var _style, _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHummingbird = function SvgHummingbird(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e37ti636rxha1",
    viewBox: "0 0 200 200",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes e37ti636rxha2_to__to{0%{transform:translate(101.602198px,101.625085px);animation-timing-function:cubic-bezier(.65,.015,.2,.77)}34.6%{transform:translate(98.280728px,94.982143px);animation-timing-function:cubic-bezier(.65,.015,.2,.77)}66%{transform:translate(98.280728px,100.676093px);animation-timing-function:cubic-bezier(.65,.015,.2,.77)}98%,to{transform:translate(101.602198px,101.625085px)}}@keyframes e37ti636rxha3_tr__tr{0%,16%,24%,36%,44%,54%,6%,62%,66%,68%,74%,84%,92%,to{transform:translate(77.455021px,86.767992px) rotate(19.975912deg)}10%,12%,2%,20%,28%,40%,48%,50%,58%,70%,78%,80%,88%{transform:translate(77.455021px,86.767992px) rotate(1.599986deg)}14%,32%,4%,52%,72%,82%{transform:translate(77.455021px,86.767992px) rotate(19.901602deg)}18%,26%,46%,56%,76%,8%,86%{transform:translate(77.455021px,86.767992px) rotate(5.653527deg)}22%,60%,90%{transform:translate(77.455021px,86.767992px) rotate(13.353179deg)}}@keyframes e37ti636rxha4_tr__tr{0%,10%,20%,26%,36%,46%,52%,62%,72%,78%,88%,98%{transform:translate(77.455021px,86.767992px) rotate(9.574704deg)}12%,2%,22%,28%,38%,48%,54%,64%,74%,80%,90%,to{transform:translate(77.455021px,86.767992px) rotate(20.875686deg)}14%,24%,30%,4%,40%,50%,56%,66%,76%,82%,92%{transform:translate(77.455021px,86.767992px) rotate(1.718954deg)}16%,32%,42%,58%,6%,68%,84%,94%{transform:translate(77.455021px,86.767992px) rotate(14.71621deg)}18%,34%,44%,60%,70%,8%,86%,96%{transform:translate(77.455021px,86.767992px) rotate(-1.147186deg)}}@keyframes e37ti636rxha5_tr__tr{0%,10%,20%,26%,36%,46%,52%,62%,72%,78%,88%,98%{transform:translate(77.455021px,86.767992px) rotate(16.858146deg)}12%,2%,22%,28%,38%,48%,54%,64%,74%,80%,90%,to{transform:translate(77.455021px,86.767992px) rotate(1.580454deg)}14%,24%,30%,4%,40%,50%,56%,66%,76%,82%,92%{transform:translate(77.455021px,86.767992px) rotate(14.470077deg)}16%,32%,42%,58%,6%,68%,84%,94%{transform:translate(77.455021px,86.767992px) rotate(1.074592deg)}18%,34%,44%,60%,70%,8%,86%,96%{transform:translate(77.455021px,86.767992px) rotate(23.355562deg)}}@keyframes e37ti636rxha6_tr__tr{0%,10%,14%,18%,22%,30%,36%,40%,44%,48%,56%,62%,66%,70%,74%,82%,88%,92%,96%{transform:translate(77.455021px,86.767992px) rotate(21.969849deg)}16%,24%,32%,42%,58%,6%,68%,76%,84%,94%{transform:translate(77.455021px,86.767992px) rotate(10.864079deg)}34%,60%,8%,86%{transform:translate(77.455021px,86.767992px) rotate(11.549249deg)}12%,38%,64%,90%{transform:translate(77.455021px,86.767992px) rotate(25.483385deg)}20%,46%,72%,98%{transform:translate(77.455021px,86.767992px) rotate(1.840144deg)}to{transform:translate(77.455021px,86.767992px) rotate(6.352112deg)}}@keyframes e37ti636rxha16_tr__tr{0%,26%,52%,78%{transform:translate(77.455021px,86.767992px) rotate(0deg)}12%,18%,2%,28%,38%,44%,54%,64%,70%,80%,90%,96%{transform:translate(77.455021px,86.767992px) rotate(5.411246deg)}14%,20%,30%,34%,4%,40%,46%,56%,60%,66%,72%,8%,82%,86%,92%,98%{transform:translate(77.455021px,86.767992px) rotate(12.028888deg)}10%,16%,22%,32%,36%,42%,48%,58%,6%,62%,68%,74%,84%,88%,94%,to{transform:translate(77.455021px,86.767992px) rotate(16.306843deg)}24%,50%,76%{transform:translate(77.455021px,86.767992px) rotate(1.31099deg)}}@keyframes e37ti636rxha17_tr__tr{0%,10%,24%,26%,36%,50%,52%,62%,76%,78%,88%{transform:translate(77.455021px,86.767992px) rotate(-5.761641deg)}12%,2%,28%,38%,54%,64%,80%,90%{transform:translate(77.455021px,86.767992px) rotate(14.459649deg)}14%,30%,4%,40%,56%,66%,82%,92%{transform:translate(77.455021px,86.767992px) rotate(.161715deg)}16%,20%,32%,42%,46%,58%,6%,68%,72%,84%,94%,98%{transform:translate(77.455021px,86.767992px) rotate(14.828606deg)}18%,22%,34%,44%,48%,60%,70%,74%,8%,86%,96%,to{transform:translate(77.455021px,86.767992px) rotate(5.985352deg)}}@keyframes e37ti636rxha18_tr__tr{0%,26%,52%,78%{transform:translate(77.455021px,86.767992px) rotate(-12.57892deg)}12%,2%,20%,28%,34%,38%,46%,54%,60%,64%,72%,8%,80%,86%,90%,98%{transform:translate(77.455021px,86.767992px) rotate(16.488394deg)}30%,4%,56%,82%{transform:translate(77.455021px,86.767992px) rotate(-5.728252deg)}10%,14%,18%,22%,32%,36%,40%,44%,48%,58%,6%,62%,66%,70%,74%,84%,88%,92%,96%,to{transform:translate(77.455021px,86.767992px) rotate(2.523493deg)}16%,24%,42%,50%,68%,76%,94%{transform:translate(77.455021px,86.767992px) rotate(15.901477deg)}}@keyframes e37ti636rxha19_tr__tr{0%,10%,12%,16%,22%,26%,30%,36%,4%,40%,46%,48%,52%,56%,60%,66%,68%,72%,76%,80%,86%,88%,92%,96%,to{transform:translate(77.455021px,86.767992px) rotate(-27.864329deg)}2%,38%,58%,78%,98%{transform:translate(77.455021px,86.767992px) rotate(-50.690949deg)}42%,6%,62%,82%{transform:translate(77.455021px,86.767992px) rotate(-51.227294deg)}14%,20%,28%,34%,44%,50%,64%,70%,8%,84%,90%{transform:translate(77.455021px,86.767992px) rotate(7.411542deg)}18%,32%,54%,74%,94%{transform:translate(77.455021px,86.767992px) rotate(-8.148997deg)}24%{transform:translate(77.455021px,86.767992px) rotate(-31.67171deg)}}@keyframes e37ti636rxha20_tr__tr{0%,26%,52%,78%{transform:translate(77.455021px,86.767992px) rotate(-54.136781deg)}10%,18%,2%,28%,36%,44%,54%,62%,70%,80%,88%,96%{transform:translate(77.455021px,86.767992px) rotate(-26.775553deg)}30%,38%,4%,46%,56%,64%,72%,82%,90%,98%{transform:translate(77.455021px,86.767992px) rotate(-14.559717deg)}22%,32%,40%,48%,58%,6%,66%,74%,84%,92%,to{transform:translate(77.455021px,86.767992px) rotate(1.81799deg)}16%,24%,34%,42%,50%,60%,68%,76%,8%,86%,94%{transform:translate(77.455021px,86.767992px) rotate(10.85276deg)}12%{transform:translate(77.455021px,86.767992px) rotate(-39.970338deg)}14%{transform:translate(77.455021px,86.767992px) rotate(-24.730576deg)}20%{transform:translate(77.455021px,86.767992px) rotate(-85.015981deg)}}@keyframes e37ti636rxha21_tr__tr{0%,26%,52%,78%{transform:translate(77.455021px,86.767992px) rotate(0deg)}12%,2%,20%,28%,32%,38%,46%,54%,58%,6%,64%,72%,80%,84%,90%,98%{transform:translate(77.455021px,86.767992px) rotate(5.77754deg)}10%,18%,30%,36%,4%,44%,56%,62%,70%,82%,88%,96%{transform:translate(77.455021px,86.767992px) rotate(-16.259511deg)}16%,34%,42%,60%,68%,8%,86%,94%{transform:translate(77.455021px,86.767992px) rotate(-.622269deg)}14%,22%,24%,40%,48%,50%,66%,74%,76%,92%,to{transform:translate(77.455021px,86.767992px) rotate(-12.582845deg)}}@keyframes e37ti636rxha22_tr__tr{0%,16%,26%,42%,52%,68%,78%,94%{transform:translate(77.455021px,86.767992px) rotate(4.040877deg)}18%,2%,28%,44%,54%,70%,80%,96%{transform:translate(77.455021px,86.767992px) rotate(-9.320057deg)}10%,20%,30%,36%,4%,46%,56%,62%,72%,82%,88%,98%{transform:translate(77.455021px,86.767992px) rotate(10.830599deg)}12%,22%,32%,38%,48%,58%,6%,64%,74%,84%,90%,to{transform:translate(77.455021px,86.767992px) rotate(9.785384deg)}14%,24%,34%,40%,50%,60%,66%,76%,8%,86%,92%{transform:translate(77.455021px,86.767992px) rotate(-4.886148deg)}}@keyframes e37ti636rxha23_tr__tr{0%,16%,22%,24%,26%,32%,42%,48%,50%,52%,58%,6%,68%,74%,76%,78%,84%,94%,to{transform:translate(77.455021px,86.767992px) rotate(17.051415deg)}18%,2%,28%,34%,44%,54%,60%,70%,8%,80%,86%,96%{transform:translate(77.455021px,86.767992px) rotate(-10.73356deg)}12%,20%,30%,38%,4%,46%,56%,64%,72%,82%,90%,98%{transform:translate(77.455021px,86.767992px) rotate(7.038524deg)}10%,36%,62%,88%{transform:translate(77.455021px,86.767992px) rotate(-10.124915deg)}14%,40%,66%,92%{transform:translate(77.455021px,86.767992px) rotate(.364373deg)}}@keyframes e37ti636rxha24_tr__tr{0%,26%,52%,78%{transform:translate(77.455021px,86.767992px) rotate(41.624941deg)}10%,16%,2%,22%,28%,30%,34%,36%,4%,42%,48%,54%,56%,60%,62%,68%,74%,8%,80%,82%,86%,88%,94%,to{transform:translate(77.455021px,86.767992px) rotate(16.724223deg)}12%,14%,20%,32%,38%,40%,46%,58%,6%,64%,66%,72%,84%,90%,92%,98%{transform:translate(77.455021px,86.767992px) rotate(-.459748deg)}18%,24%,44%,50%,70%,76%,96%{transform:translate(77.455021px,86.767992px) rotate(-2.350261deg)}}@keyframes e37ti636rxha25_tr__tr{0%,10%,20%,26%,36%,46%,52%,62%,72%,78%,88%,98%{transform:translate(77.455021px,86.767992px) rotate(-21.195784deg)}12%,2%,22%,28%,38%,48%,54%,64%,74%,80%,90%,to{transform:translate(77.455021px,86.767992px) rotate(-4.296754deg)}14%,24%,30%,4%,40%,50%,56%,66%,76%,82%,92%{transform:translate(77.455021px,86.767992px) rotate(-7.888741deg)}16%,32%,42%,58%,6%,68%,84%,94%{transform:translate(77.455021px,86.767992px) rotate(-2.450295deg)}18%,34%,44%,60%,70%,8%,86%,96%{transform:translate(77.455021px,86.767992px) rotate(4.125857deg)}}@keyframes e37ti636rxha26_tr__tr{0%,26%,52%,78%{transform:translate(77.455021px,86.767992px) rotate(-6.52052deg)}10%,18%,2%,28%,36%,44%,54%,62%,70%,80%,88%,96%{transform:translate(77.455021px,86.767992px) rotate(8.937663deg)}12%,20%,30%,38%,4%,46%,56%,64%,72%,82%,90%,98%{transform:translate(77.455021px,86.767992px) rotate(15.060172deg)}14%,22%,32%,40%,48%,58%,6%,66%,74%,84%,92%,to{transform:translate(77.455021px,86.767992px) rotate(-8.118905deg)}16%,24%,34%,42%,50%,60%,68%,76%,8%,86%,94%{transform:translate(77.455021px,86.767992px) rotate(1.031776deg)}}@keyframes e37ti636rxha27_tr__tr{0%,16%,26%,34%,42%,52%,60%,68%,78%,8%,86%,94%{transform:translate(77.455021px,86.767992px) rotate(-15.178043deg)}10%,18%,2%,28%,36%,44%,54%,62%,70%,80%,88%,96%{transform:translate(77.455021px,86.767992px) rotate(7.113715deg)}12%,20%,30%,38%,4%,46%,56%,64%,72%,82%,90%,98%{transform:translate(77.455021px,86.767992px) rotate(4.268694deg)}14%,22%,32%,40%,48%,58%,6%,66%,74%,84%,92%,to{transform:translate(77.455021px,86.767992px) rotate(-10.339789deg)}24%,50%,76%{transform:translate(77.455021px,86.767992px) rotate(7.680666deg)}}@keyframes e37ti636rxha28_tr__tr{0%,26%,52%,78%{transform:translate(77.455021px,86.767992px) rotate(-9.153452deg)}14%,2%,28%,40%,54%,66%,80%,92%{transform:translate(77.455021px,86.767992px) rotate(15.235098deg)}12%,16%,30%,38%,4%,42%,56%,64%,68%,82%,90%,94%{transform:translate(77.455021px,86.767992px) rotate(-6.578332deg)}10%,18%,22%,32%,36%,44%,48%,58%,6%,62%,70%,74%,84%,88%,96%,to{transform:translate(77.455021px,86.767992px) rotate(10.863194deg)}20%,24%,34%,46%,50%,60%,72%,76%,8%,86%,98%{transform:translate(77.455021px,86.767992px) rotate(-13.71797deg)}}")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(101.6 101.63)",
    style: {
      animation: "e37ti636rxha2_to__to 5000ms linear infinite normal forwards"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "e37ti636rxha2",
    transform: "rotate(66.21 119.04 -31.42)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(19.98 -207.62 263.29)",
    style: {
      animation: "e37ti636rxha3_tr__tr 5000ms linear infinite normal forwards"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "e37ti636rxha3",
    d: "M81 101c.34 0 .58-51.81.58-51.81C91.81 52.48 110 80.07 81 101z",
    transform: "matrix(1 0 0 -1 -81.01 100.8)",
    opacity: 0.2,
    fill: "#A0C0E5",
    stroke: "none",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(9.57 -479.29 505.8)",
    style: {
      animation: "e37ti636rxha4_tr__tr 5000ms linear infinite normal forwards"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "e37ti636rxha4",
    d: "M81 101c.34 0 .58-51.81.58-51.81C91.81 52.48 110 80.07 81 101z",
    transform: "matrix(1 0 0 -.90763 -81.01 91.5)",
    opacity: 0.2,
    fill: "#A0C0E5",
    stroke: "none",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(16.86 -254.04 304.73)",
    style: {
      animation: "e37ti636rxha5_tr__tr 5000ms linear infinite normal forwards"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "e37ti636rxha5",
    d: "M83.55 101c.29 0 .49-43.38.49-43.38 8.56 2.76 23.8 25.86-.49 43.38z",
    transform: "matrix(.84899 0 0 -.88158 -68.78 88.87)",
    opacity: 0.2,
    fill: "#A0C0E5",
    stroke: "none",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(21.97 -184.78 242.9)",
    style: {
      animation: "e37ti636rxha6_tr__tr 5000ms linear infinite normal forwards"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "e37ti636rxha6",
    d: "M83.55 101c.29 0 .49-43.38.49-43.38 8.56 2.76 23.8 25.86-.49 43.38z",
    transform: "matrix(.84899 0 0 -.6504 -68.78 65.57)",
    opacity: 0.2,
    fill: "#A0C0E5",
    stroke: "none",
    strokeWidth: 1
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e37ti636rxha7",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    id: "e37ti636rxha8",
    d: "M59.25 122.42C57.84 102.18 71.39 99 77.5 102.17c6.11 3.17 21.55-18.25 53.22-11.73-10.7 22-28.84 32.13-42.33 28.66-13.49-3.47-24.67-1.66-29.14 3.32z",
    transform: "translate(-3.55 -14.04)",
    fill: "#FFF5EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e37ti636rxha9",
    d: "M78.3 102.61c6.43 9.27 22.79 22.46 43.61-13.45-24.19-1.26-43.61 13.45-43.61 13.45z",
    transform: "translate(-3.55 -14.04)",
    fill: "#FAAF40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e37ti636rxha10",
    d: "M78 117.39l.31-14.78s-17.65 9.6-19 19.81c5.45-5.95 18.69-5.03 18.69-5.03z",
    transform: "translate(-3.55 -14.04)",
    fill: "#F05A28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e37ti636rxha11",
    d: "M59.25 122.42c3.18-10 19-19.81 19-19.81-8.4-8.02-22.25 5.1-19 19.81z",
    transform: "translate(-3.55 -14.04)",
    fill: "#FAAF40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e37ti636rxha12",
    transform: "translate(46.82 35.11)",
    fill: "#603813",
    d: "M13.4 62.46l2.47 2.31 1.63-3.34-4.1 1.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e37ti636rxha13",
    d: "M58.78 118.38l2.6 2.37c-3.87 4.1-7.45 8.47-10.71 13.07l-.3-.21c3.18-5.27 7.63-12.05 8.41-15.23z",
    transform: "translate(-3.55 -14.04)",
    fill: "#603813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e37ti636rxha14",
    d: "M128.73 92.6l11.17 10.68-3.11-9.75s11.53 3.25 17.51 1.69l-15-5a47.24 47.24 0 0014.59-8.5l-32 7.46z",
    transform: "translate(-3.55 -14.04)",
    fill: "#603813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e37ti636rxha15",
    d: "M117 106.3h-.06a.44.44 0 00-.25.06.52.52 0 00-.17.19.46.46 0 000 .26l1.26 7.36a.5.5 0 001-.17l-.78-4.56 2.18 3.82c.14.24.44.32.68.19.1-.05.17-.14.21-.24a.51.51 0 000-.45l-2.28-4 4.39 3.54c.22.17.53.13.71-.08a.6.6 0 00.06-.11.5.5 0 00-.14-.59l-6.44-5.2a.5.5 0 00-.37-.02z",
    transform: "translate(-3.55 -14.04)",
    fill: "#603813"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.46 86.77)",
    style: {
      animation: "e37ti636rxha16_tr__tr 5000ms linear infinite normal forwards"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "e37ti636rxha16",
    d: "M81 101c.34 0 .58-51.81.58-51.81C91.81 52.48 110 80.07 81 101z",
    transform: "matrix(1 0 0 -1 -81.01 100.8)",
    opacity: 0.2,
    fill: "#A0C0E5",
    stroke: "none",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-5.76 900.85 -726.2)",
    style: {
      animation: "e37ti636rxha17_tr__tr 5000ms linear infinite normal forwards"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "e37ti636rxha17",
    d: "M81 101c.34 0 .58-51.81.58-51.81C91.81 52.48 110 80.07 81 101z",
    transform: "matrix(.81862 0 0 -.80776 -66.32 81.43)",
    opacity: 0.2,
    fill: "#A0C0E5",
    stroke: "none",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-12.58 432.36 -308)",
    style: {
      animation: "e37ti636rxha18_tr__tr 5000ms linear infinite normal forwards"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "e37ti636rxha18",
    d: "M81 101c.34 0 .58-51.81.58-51.81C91.81 52.48 110 80.07 81 101z",
    transform: "matrix(.81862 0 0 -.60918 -66.32 61.4)",
    opacity: 0.2,
    fill: "#A0C0E5",
    stroke: "none",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-27.86 213.61 -112.73)",
    style: {
      animation: "e37ti636rxha19_tr__tr 5000ms linear infinite normal forwards"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "e37ti636rxha19",
    d: "M81 101c.34 0 .58-51.81.58-51.81C91.81 52.48 110 80.07 81 101z",
    transform: "matrix(.77181 0 0 -.35263 -62.52 35.55)",
    opacity: 0.2,
    fill: "#A0C0E5",
    stroke: "none",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-54.14 123.62 -32.4)",
    style: {
      animation: "e37ti636rxha20_tr__tr 5000ms linear infinite normal forwards"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "e37ti636rxha20",
    d: "M81 101c.34 0 .58-51.81.58-51.81C91.81 52.48 110 80.07 81 101z",
    transform: "matrix(.81862 0 0 -.33595 -66.32 33.87)",
    opacity: 0.2,
    fill: "#A0C0E5",
    stroke: "none",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.46 86.77)",
    style: {
      animation: "e37ti636rxha21_tr__tr 5000ms linear infinite normal forwards"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "e37ti636rxha21",
    d: "M81 101c.34 0 .58-51.81.58-51.81C91.81 52.48 110 80.07 81 101z",
    transform: "translate(-81.01 -100.8)",
    opacity: 0.2,
    fill: "#A0C0E5",
    stroke: "none",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(4.04 -1191.05 1141.17)",
    style: {
      animation: "e37ti636rxha22_tr__tr 5000ms linear infinite normal forwards"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "e37ti636rxha22",
    d: "M81 101c.34 0 .58-51.81.58-51.81C91.81 52.48 110 80.07 81 101z",
    transform: "matrix(.74107 0 0 .78718 -60.03 -79.35)",
    opacity: 0.2,
    fill: "#A0C0E5",
    stroke: "none",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(17.05 -250.67 301.72)",
    style: {
      animation: "e37ti636rxha23_tr__tr 5000ms linear infinite normal forwards"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "e37ti636rxha23",
    d: "M81 101c.34 0 .58-51.81.58-51.81C91.81 52.48 110 80.07 81 101z",
    transform: "matrix(.69063 0 0 .59639 -55.95 -60.12)",
    opacity: 0.2,
    fill: "#A0C0E5",
    stroke: "none",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(41.62 -75.4 145.27)",
    style: {
      animation: "e37ti636rxha24_tr__tr 5000ms linear infinite normal forwards"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "e37ti636rxha24",
    d: "M81 101c.34 0 .58-51.81.58-51.81C91.81 52.48 110 80.07 81 101z",
    transform: "matrix(.69063 0 0 .40208 -55.95 -40.53)",
    opacity: 0.2,
    fill: "#A0C0E5",
    stroke: "none",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-21.2 270.6 -163.6)",
    style: {
      animation: "e37ti636rxha25_tr__tr 5000ms linear infinite normal forwards"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "e37ti636rxha25",
    d: "M81 101c.34 0 .58-51.81.58-51.81C91.81 52.48 110 80.07 81 101z",
    transform: "translate(-81.01 -100.8)",
    opacity: 0.2,
    fill: "#A0C0E5",
    stroke: "none",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-6.52 800.33 -636.48)",
    style: {
      animation: "e37ti636rxha26_tr__tr 5000ms linear infinite normal forwards"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "e37ti636rxha26",
    d: "M81 101c.34 0 .58-51.81.58-51.81C91.81 52.48 110 80.07 81 101z",
    transform: "matrix(1 0 0 .95213 -81.01 -95.98)",
    opacity: 0.2,
    fill: "#A0C0E5",
    stroke: "none",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-15.18 364.35 -247.29)",
    style: {
      animation: "e37ti636rxha27_tr__tr 5000ms linear infinite normal forwards"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "e37ti636rxha27",
    d: "M81 101c.34 0 .58-51.81.58-51.81C91.81 52.48 110 80.07 81 101z",
    transform: "matrix(.70163 0 0 .8213 -56.84 -82.8)",
    opacity: 0.2,
    fill: "#A0C0E5",
    stroke: "none",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-9.15 580.7 -440.41)",
    style: {
      animation: "e37ti636rxha28_tr__tr 5000ms linear infinite normal forwards"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "e37ti636rxha28",
    d: "M81 101c.34 0 .58-51.81.58-51.81C91.81 52.48 110 80.07 81 101z",
    transform: "matrix(.70163 0 0 .525 -56.84 -52.92)",
    opacity: 0.2,
    fill: "#A0C0E5",
    stroke: "none",
    strokeWidth: 1
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHummingbird, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hummingbird.77c05622.svg";
export { ForwardRef as ReactComponent };